class Config {
    static SETTINGS = {
        /*API_URL:'https://dev.seatup.co.il/api/',*/
        API_URL:window.location.hostname === "localhost" ? "https://app.seatup.co.il/api/" : (window.location.hostname.startsWith("19") ? "https://app.seatup.co.il/api/" : `https://${window.location.hostname}/api/`),
        APP_URL:window.location.hostname === "localhost" ? "https://app.seatup.co.il/" : (window.location.hostname.startsWith("19") ? "https://app.seatup.co.il/" : `https://${window.location.hostname}/`),
    };
    static API_ROUTES = {
        'login':'login',
        'isLogged':'isLogged',
        'dashboard':'dashboard',
        'users':'users',
        'appointments':'appointments',
        'quotations':'quotations',
        'contact':'contact',
        'events':'events',
        'guests':'guests',
        'upload':'fileUpload',
        'halls':'halls',
        'tables':'tables',
        'reports':'reports',
        'presets':'presets',
        'settings':'appSettings',
        'calendar':'calendar',
        'equipments':'equipment',
        'banners':'banners'
    }
    static DEFAULT_API_SETTINGS = {headers: {'Content-Type': 'text/json'},withCredentials: true};

    static GUEST_STATUS = {
        'notResponded':0,
        'coming':1,
        'maybe':2,
        'notComing':3,
    }

};

export default Config
